import {
  faNotesMedical,
  faPenToSquare,
  faTrashCan,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  DropOptions,
  MultiBackend,
  NodeModel,
  Tree,
  getBackendOptions,
} from '@minoru/react-dnd-treeview';
import { useEffect, useState } from 'react';
import { DndProvider } from 'react-dnd';
import { useSelector } from 'react-redux';
import { TreeProps } from '../../Interfaces/Props';
import { IRootState } from '../../Storage/Redux/store';
import { MainLoader } from '../Common';
import { IconCaretDown, IconFolder } from '../Icon';

function TreeComp(props: TreeProps) {
  const themeConfig = useSelector((state: IRootState) => state.themeConfig);

  const [treeNode, setTreeNode] = useState<NodeModel[]>([]);
  const [dropTargetClass, setDropTargetClass] = useState('dropTargetDark');
  const showDependentBtn = props.showDependentBtn ?? true;
  const showAddBtn = props.showAddBtn ?? true;

  useEffect(() => {
    setTreeNode(props.data);
    if (themeConfig.isDarkMode) {
      setDropTargetClass('dropTargetDark');
    } else {
      setDropTargetClass('dropTarget');
    }
  }, [props.data, themeConfig.isDarkMode]);

  const handleDrop = (tree: NodeModel[], options: DropOptions) => {
    props.dropTarget(options);
    setTreeNode(tree);
  };

  if (treeNode.length === 0 && props.data.length !== 0) {
    return <MainLoader />;
  }

  return (
    <DndProvider backend={MultiBackend} options={getBackendOptions()}>
      <div className="treeDivApp">
        <Tree
          tree={treeNode}
          rootId={0}
          classes={{
            root: 'font-semibold treeRoot',
            listItem: 'py-[5px] ltr:pl-7 rtl:pr-7',
            draggingSource: 'draggingSource',
            dropTarget: dropTargetClass,
          }}
          initialOpen={props.initialAllOpen}
          onDrop={handleDrop}
          enableAnimateExpand={true}
          dragPreviewRender={(monitorProps) => (
            <div>
              <IconFolder className="text-primary inline relative -top-1 ltr:mr-2 rtl:ml-2" />
              <strong>{monitorProps.item.text}</strong>
            </div>
          )}
          render={(node, { depth, isOpen, onToggle }) => (
            <div
              className="flex flex-col items-start flex-1 text-center md:text-left"
              style={{ marginLeft: depth * 10 }}
            >
              <div className="relative inline-block group">
                <button
                  type="button"
                  className={`${
                    isOpen ? 'active' : ''
                  } relative z-10 flex items-center justify-center px-4 py-2 focus:outline-none group-hover:transition duration-300`}
                  onClick={onToggle}
                >
                  <IconCaretDown
                    className={`w-5 h-5 text-primary inline relative -top-1 ltr:mr-2 rtl:ml-2 ${
                      isOpen && 'rotate-180'
                    }`}
                  />
                  {props?.icon ? (
                    <props.icon className="text-success inline size-5 relative -top-1 ltr:mr-2 rtl:ml-2" />
                  ) : (
                    <IconFolder className="text-primary inline relative -top-1 ltr:mr-2 rtl:ml-2" />
                  )}
                  {node.text}
                </button>
                {!props?.hideAllButton && (
                  <div
                    className={
                      props.isFixedAddEditButton
                        ? 'flex items-center absolute -top-1 left-full'
                        : 'absolute -top-1 left-full flex shadow-md overflow-hidden opacity-0 items-center translate-x-full group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 justify-between'
                    }
                  >
                    <FontAwesomeIcon
                      icon={faPenToSquare}
                      className="px-2 py-1 text-primary text-lg cursor-pointer hover:focus:outline-none"
                      onClick={() => props.openExistModal(node.data!)}
                    />
                    {showDependentBtn && (
                      <div className="p-2">
                        <FontAwesomeIcon
                          className="px-2 py-1 text-primary text-lg cursor-pointer hover:focus:outline-none"
                          onClick={() => props.openNewModal(Number(node.id))}
                          icon={faNotesMedical}
                        />
                      </div>
                    )}
                    {props.deleteNode && (
                      <FontAwesomeIcon
                        icon={faTrashCan}
                        className="px-2 py-1 text-red-700 text-lg cursor-pointer hover:focus:outline-none"
                        onClick={() => props.deleteNode!(Number(node.id))}
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
        />

        {!props?.hideAllButton &&
          ((props.disableSecondAddButton && props.data.length === 0) ||
            !props.disableSecondAddButton) && (
            <div>
              {showAddBtn && (
                <div className="py-[5px] ltr:pl-7 rtl:pr-7">
                  <button
                    type="button"
                    className="btn btn-light btn-sm"
                    onClick={() => props.openNewModal(0)}
                  >
                    <FontAwesomeIcon icon={faNotesMedical} /> Add
                  </button>
                </div>
              )}
            </div>
          )}
      </div>
    </DndProvider>
  );
}

export default TreeComp;
